export interface UnsubscribeDoneProps {
  message: string;
  title: string;
}

export const UnsubscribeDone = ({ message, title }: UnsubscribeDoneProps) => {
  return (
    <div data-testid="unsubscribeDone" className="text-center">
      <h2>{title}</h2>
      <h4>{message}</h4>
    </div>
  );
};
